import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for emails */
export type EmailsId = string & { __flavor: "EmailsId" };

/**
 * Represents the table public.emails
 * @uniqueConstraints {"emails_pkey":{"name":"emails_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"emails_created_at":{"name":"emails_created_at","isPrimary":false,"isUnique":false,"columns":[{"name":"created_at","definition":"created_at","predicate":null}]},"emails_sent_at":{"name":"emails_sent_at","isPrimary":false,"isUnique":false,"columns":[{"name":"sent_at","definition":"sent_at","predicate":null}]}}
 */
export default interface EmailsTable {
  id: ColumnType<EmailsId, EmailsId | undefined, EmailsId>;

  to: ColumnType<string, string, string>;

  subject: ColumnType<string, string, string>;

  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;

  sentAt: ColumnType<Date | null, Date | string | null, Date | string | null>;
}

export type Emails = Selectable<EmailsTable>;

export type NewEmails = Insertable<EmailsTable>;

export type EmailsUpdate = Updateable<EmailsTable>;

export const emailsId = z.string() as unknown as z.Schema<EmailsId>;

export const emails = z.object({
  id: emailsId,
  to: z.string(),
  subject: z.string(),
  createdAt: z.date(),
  sentAt: z.date().nullable(),
});

export const emailsInitializer = z.object({
  id: emailsId.optional(),
  to: z.string(),
  subject: z.string(),
  createdAt: z.date().optional(),
  sentAt: z.date().optional().nullable(),
});

export const emailsMutator = z.object({
  id: emailsId.optional(),
  to: z.string().optional(),
  subject: z.string().optional(),
  createdAt: z.date().optional(),
  sentAt: z.date().optional().nullable(),
});

// ── constraints for Emails ─────────────────────────────────
export const EmailsConstraints = {
  emails_pkey: {
    name: "emails_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  emails_created_at: {
    name: "emails_created_at",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "created_at", definition: "created_at", predicate: null }],
  },
  emails_sent_at: {
    name: "emails_sent_at",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "sent_at", definition: "sent_at", predicate: null }],
  },
} as const;
export type EmailsConstraintsType = typeof EmailsConstraints;
